module.exports = __webpack_public_path__ + "static/media/statsPie.93726c7e.svg";